import { render, staticRenderFns } from "./ProductIntroduce.vue?vue&type=template&id=21d4614a&scoped=true&"
import script from "./ProductIntroduce.vue?vue&type=script&lang=js&"
export * from "./ProductIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroduce.vue?vue&type=style&index=0&id=21d4614a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4614a",
  null
  
)

export default component.exports